export const DEFAULT_LOCALE = 'en-GB';
